import Immutable from 'immutable';
import * as actions from './constants';

const initialState = Immutable.Map({
    visible: false,
    message: ''
});

export default (state = initialState, action) => {
    switch (action.type) {
        case actions.TOGGLE_LOADING:
            return state.withMutations(map => {
                map.set('visible', action.visible);
                map.set('message', action.message);
            });
        default:
            return state;
    }
}
